import { defineStore } from 'pinia'

const state = () => ({
  articleCategories: {
    en: [],
    es: []
  },
  articlesBySlug: {},
  articlesByCategorySlug: {},
  homeContent: [],
  activeContent: {
    type: '',
    id: '',
    slug: ''
  },
  events: {
    en: [],
    es: []
  },
  eventsBySlug: {
    en: {},
    es: {}
  },
  discountsBySlug: {
    en: {},
    es: {}
  },
  discountCategories: {
    en: [],
    es: []
  },
  cities: [],
  discountsByCategoryCityIds: {},
  myDiscounts: [],
  videos: {
    en: {},
    es: {}
  },
  videosBySlug:{
    en: {},
    es: {}
  }
})

const actions = {
  setCategories (categories) {
    this.categories = categories
  }, 
  setHomeContent (content) {
      this.homeContent = content
  },
  setArticleCategories ( locale, categories ) {
    this.articleCategories[locale] = categories
  },
  setArticleBySlug( slug, response ) {
    this.articlesBySlug[slug] = response
  },
  setEvents(events) {
    this.events = events
  },
  setEventBySlug( locale, slug, event){
    this.eventsBySlug[locale][slug] = event
  },
  setActiveContent (type, id = '', slug = '') {
    this.activeContent = { type, id, slug }
  },
  setCities(cities){
    this.cities = cities
  },
  createDiscountByCategoryCityIds(categoryId, cityId){
    this.discountsByCategoryCityIds[`${categoryId}-${cityId}`] = {
      count: 0,
      discounts: []
    }    
  },
  setDiscountByCategoryCityIdsCount(categoryId, cityId, val){
    this.discountsByCategoryCityIds[`${categoryId}-${cityId}`].count = val
  },
  addDiscountByCategoryCityIds(categoryId, cityId, val){
    this.discountsByCategoryCityIds[`${categoryId}-${cityId}`].discounts.push(...val)
  },
  setDiscountCategories (slug,categories) {
    this.discountCategories[slug] = categories
  },
  setDiscountBySlug(locale,slug,discount){
    this.discountsBySlug[locale][slug] = discount
  },
  setArticlesByCategorySlug(categorySlug,articles){
    this.articlesByCategorySlug[categorySlug] = articles
  },
  setAllVideos(locale,videos){
    this.videos[locale] = videos
  },
  setVideoBySlug(locale,slug,discount){
    this.videosBySlug[locale][slug] = discount
  },
}

export const useCommunityStore = defineStore('community', {
  state: () => state(),
  actions
})

export default useCommunityStore
